var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"block","padding-top":"70px"}},[_c('img',{staticClass:"globall",attrs:{"src":require("../assets/warning.png")}}),_c('h1',[_vm._v("NO INVOICE NUMBER")]),_c('h1',{staticStyle:{"padding-left":"70px"}},[_vm._v("DETECTED!")])])
}]

export { render, staticRenderFns }